import type { SortOrder } from './types';

export const SortMenuItemsConfig: {
  text: string;
  value: SortOrder;
}[] = [
  {
    text: 'Relevance',
    value: 'relevance,desc',
  },
  {
    text: 'Date',
    value: 'date,asc',
  },
  {
    text: 'Highest Rating',
    value: 'rating,desc',
  },
  {
    text: 'Lowest Rating',
    value: 'rating,asc',
  },
];
